import { useMemo } from 'react';
import { useVideoProgress } from './useVideoProgress';
import {
  PATIENT_EDUCATION_MODULES,
  PatientEducationModule,
} from '../data/education/patientEducationModules';

export type ModuleWithProgress = PatientEducationModule & {
  completed: boolean;
  lastPosition: number;
  duration: number;
};

export function useEducationModulesProgress(patientId: string) {
  const { getProgress, isReady } = useVideoProgress(patientId);

  return useMemo(() => {
    const modules: ModuleWithProgress[] = PATIENT_EDUCATION_MODULES.map((m) => {
      const entry = getProgress(m.videoId);
      return {
        ...m,
        completed: entry?.completed ?? false,
        lastPosition: entry?.lastPosition ?? 0,
        duration: entry?.duration ?? 0,
      };
    });

    const allCompleted = modules.every((m) => m.completed);

    let currentModuleIndex = modules.findIndex((m) => !m.completed);
    if (currentModuleIndex === -1) {
      currentModuleIndex = modules.length - 1;
    }

    return { modules, allCompleted, currentModuleIndex, isReady };
  }, [getProgress, isReady]);
}
